import { type ReactNode, type SVGProps } from 'react';

type IconProps = SVGProps<SVGSVGElement> & { size?: number };

function I({ size = 18, children, ...p }: IconProps & { children: ReactNode }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...p}
    >
      {children}
    </svg>
  );
}

export const Icon = {
  Dashboard: (p: IconProps) => (
    <I {...p}>
      <rect x="3" y="3" width="7" height="9" rx="1.5" />
      <rect x="14" y="3" width="7" height="5" rx="1.5" />
      <rect x="14" y="12" width="7" height="9" rx="1.5" />
      <rect x="3" y="16" width="7" height="5" rx="1.5" />
    </I>
  ),
  Users: (p: IconProps) => (
    <I {...p}>
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </I>
  ),
  Rooms: (p: IconProps) => (
    <I {...p}>
      <path d="M3 9.5 12 4l9 5.5" />
      <path d="M5 10v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-9" />
      <path d="M9 21V12h6v9" />
    </I>
  ),
  Cash: (p: IconProps) => (
    <I {...p}>
      <rect x="2" y="6" width="20" height="12" rx="2" />
      <circle cx="12" cy="12" r="3" />
      <path d="M6 12h.01M18 12h.01" />
    </I>
  ),
  Eye: (p: IconProps) => (
    <I {...p}>
      <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12Z" />
      <circle cx="12" cy="12" r="3" />
    </I>
  ),
  Shield: (p: IconProps) => (
    <I {...p}>
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z" />
    </I>
  ),
  Logout: (p: IconProps) => (
    <I {...p}>
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
      <polyline points="16 17 21 12 16 7" />
      <line x1="21" y1="12" x2="9" y2="12" />
    </I>
  ),
  Search: (p: IconProps) => (
    <I {...p}>
      <circle cx="11" cy="11" r="7" />
      <line x1="21" y1="21" x2="16.65" y2="16.65" />
    </I>
  ),
  Plus: (p: IconProps) => (
    <I {...p}>
      <line x1="12" y1="5" x2="12" y2="19" />
      <line x1="5" y1="12" x2="19" y2="12" />
    </I>
  ),
  Menu: (p: IconProps) => (
    <I {...p}>
      <line x1="3" y1="6" x2="21" y2="6" />
      <line x1="3" y1="12" x2="21" y2="12" />
      <line x1="3" y1="18" x2="21" y2="18" />
    </I>
  ),
  Close: (p: IconProps) => (
    <I {...p}>
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </I>
  ),
  Chevron: (p: IconProps) => (
    <I {...p}>
      <polyline points="9 18 15 12 9 6" />
    </I>
  ),
  ChevronsLeft: (p: IconProps) => (
    <I {...p}>
      <polyline points="11 17 6 12 11 7" />
      <polyline points="18 17 13 12 18 7" />
    </I>
  ),
  ChevronsRight: (p: IconProps) => (
    <I {...p}>
      <polyline points="13 17 18 12 13 7" />
      <polyline points="6 17 11 12 6 7" />
    </I>
  ),
  Crown: (p: IconProps) => (
    <I {...p}>
      <path d="M3 17h18l-1.5-9-4 4-3.5-6-3.5 6-4-4L3 17Z" />
      <path d="M3 21h18" />
    </I>
  ),
  Spade: (p: IconProps) => (
    <I {...p}>
      <path d="M12 2c4 4 7 7 7 11a7 7 0 0 1-14 0c0-4 3-7 7-11Z" />
      <path d="M9 18h6l-1 3h-4l-1-3Z" />
    </I>
  ),
  Pause: (p: IconProps) => (
    <I {...p}>
      <rect x="6" y="5" width="4" height="14" />
      <rect x="14" y="5" width="4" height="14" />
    </I>
  ),
  Power: (p: IconProps) => (
    <I {...p}>
      <path d="M12 2v10" />
      <path d="M5.5 5.5a9 9 0 1 0 13 0" />
    </I>
  ),
  Lock: (p: IconProps) => (
    <I {...p}>
      <rect x="4" y="11" width="16" height="10" rx="2" />
      <path d="M8 11V7a4 4 0 0 1 8 0v4" />
    </I>
  ),
  Trash: (p: IconProps) => (
    <I {...p}>
      <polyline points="3 6 5 6 21 6" />
      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" />
      <path d="M10 11v6M14 11v6" />
      <path d="M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2" />
    </I>
  ),
  Check: (p: IconProps) => (
    <I {...p}>
      <polyline points="20 6 9 17 4 12" />
    </I>
  ),
  Refresh: (p: IconProps) => (
    <I {...p}>
      <polyline points="23 4 23 10 17 10" />
      <polyline points="1 20 1 14 7 14" />
      <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10" />
      <path d="M20.49 15a9 9 0 0 1-14.85 3.36L1 14" />
    </I>
  ),
  Copy: (p: IconProps) => (
    <I {...p}>
      <rect x="9" y="9" width="13" height="13" rx="2" />
      <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
    </I>
  ),
  Bell: (p: IconProps) => (
    <I {...p}>
      <path d="M6 8a6 6 0 1 1 12 0c0 7 3 9 3 9H3s3-2 3-9" />
      <path d="M10 21a2 2 0 0 0 4 0" />
    </I>
  ),
  Spark: (p: IconProps) => (
    <I {...p}>
      <path d="M12 2v4M12 18v4M4 12H2M22 12h-2M5 5l2 2M17 17l2 2M5 19l2-2M17 7l2-2" />
    </I>
  )
};
